import Nav from './Nav'


function Pillar2() {
    let selectedPil="pillar ";
    let pillarHeading="";
    let pillar1Text="";
  
      selectedPil += " protecting-people";
      pillarHeading = "Protecting People";
      pillar1Text="The COVID-19 crisis impacts the world’s poorest and most vulnerable hardest, and so it remains of utmost importance to ensure that the population everywhere continues to have access to social services and social protection. The United Nations development system is the world’s largest international actor on social protection and basic services. The system supported Governments around the world that had to adapt, extend and scale-up social protection services, including cash transfers, food assistance programmes, social insurance programmes and child benefits to support families, among others. ";
      return(
        <>
        <Nav active="p2" />
        <div className={selectedPil}>
                  <PillarStart text={pillar1Text} pilHeading={pillarHeading} />
                  <div className="customcontainer">
                    <TopKeyFigureSection active="p2" />
                    <Pillar2IndicatorSection heading="People Reached (WASH) " indiNum="1" kfHeading="People Supported" rowChartHeading="People Supported by Subgroup" />
                    <Pillar2IndicatorSection heading="Children Supported With Distance Learning " indiNum="2" kfHeading="Children Supported" rowChartHeading="Children Supported by Subgroup" />
                    <Pillar2IndicatorSection heading="Children Receiving Meals " indiNum="3" kfHeading="Children Supported" rowChartHeading="Children Supported by Subgroup" />
                    {/* <Pillar2IndicatorSection heading="Gender Based Violence Measures " indiNum="4" kfHeading="" rowChartHeading="" /> */}
                    <Pillar2IndicatorSection heading="Beneficiaries of Social Protection Schemes" indiNum="5" kfHeading="People Supported" rowChartHeading="People Supported by Subgroup" />

                  </div>
                  <TableSection />
        </div>
        </>
      );

}

function TableSection()
{
  return(
    <div className="white-background">
      <div className="customcontainer">
          <div className="customrow">
              <div className="col-md-12">
                  <div className="title">
                      <div className="funded"></div>
                      <div className="text pillar">&nbsp;</div>
                  </div>
              </div>
              <table id="table" className="table table-hover"></table>
          </div>
      </div>
  </div>
  )
}

function PillarStart({text,pilHeading}){
    return (
      <div className="customcontainer">
                    <div className="topContent"><p>{text}</p></div>
                    <div className="customrow">
                        <div className="col-md-12">
                            <h1 className="pillar-title">
                                {pilHeading}
                            </h1>
                        </div>
                    </div>
                </div>
    )
  }

function TopKeyFigureSection({active})
{
    return(
        <div className="customrow">
          <div className="col-md-12">
            <div className="pillar2-blocks">
              <TopKeyFigure heading="DISTANCE LEARNING" div_id="1" keyFigure = "262.7 M"/>
              <TopKeyFigure heading="RECEIVING MEALS" div_id="2" keyFigure = "17.2 M"/>
              <TopKeyFigure heading="WASH SUPPLIES" div_id="3" keyFigure = "57.3 M" />
            </div>
          </div>
        </div>
      )
}

function TopKeyFigure({heading, div_id, keyFigure})
{
  let divNAid="top-number"+div_id+"NA";
  let divID="top-number"+div_id;
  return(
    <div className="pillar-block">
      <div className="header">
          <div className="text text-center">
              {heading}
          </div>
      </div>
      <div className="body">
          <div className="counter text-center">
              <span id={divNAid}></span>
              <span id={divID}>{keyFigure}</span>
          </div>
      </div>
  </div>
  )
}


function IndKeyFigure({heading,div_id,indValue})
{
  console.log(div_id);
  return(
    <>
      <div className="counter text-center">
        <span id={div_id} className="kf-number">{indValue}</span>
      </div>
      <div className="title" style={{textAlign: 'center'}}>
          <div className="text">{heading}</div>
      </div>
    </>
  )
}


function Pillar2IndicatorSection({heading,indiNum,kfHeading,rowChartHeading}){
    let indDivID="Ind2."+indiNum;
    let kfDivID="number"+indiNum;
    let qrtChartID="";
    let rowChartID="";
    let qrtChartContainerID="";
    let qrtNAContainerID="";
    let rowChartContainerID="";
    let rowNAContainerID="";
  
    if(indiNum==="1")
        {
          qrtChartID="chart1-2."+indiNum;
          rowChartID="chart2-2."+indiNum;
          qrtChartContainerID="quater"+indiNum;
          rowChartContainerID="indicator"+indiNum;
          qrtNAContainerID="2."+indiNum+"chart1NA";
          rowNAContainerID="2."+indiNum+"chart2NA";
      
          return(
            <div id={indDivID} className="customrow">
              <div className="pillar health-first">
                  <div className="customcontainer">
                      <div className="customrow">
                          <div className="col-md-12">
                              <h1 className="indicator-title">
                                  {heading}
                              </h1>
                          </div>
                      </div>
                  </div>
              </div>
              <div className="col-md-2">
                <div className="funded">
                  <div className="body">
                    <div className="burger">
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                    </div>
                    <IndKeyFigure heading={kfHeading} div_id={kfDivID} unit="" indValue = "57.3 M"/>
                  </div>
                </div>
              </div>
              <div id={qrtChartID} className="col-md-5">
                <div className="funded">
                    <div className="title">
                        <div className="text">Quarterly Progress</div>
                    </div>
                    <div className="content">
                        <div id={qrtChartContainerID}>
                        </div>
                        <div id={qrtNAContainerID} className="title" style={{textAlign: 'center'}}>
                        <canvas style={{height: '130px', width:'130px', backgroundColor: '#fff'}} id="CG2.1a" width="50" height="50" />
                            <div className="kf-number" style={{paddingTop: '70px', display: 'none'}}>N/A</div>
                        </div>
                    </div>
                </div>
              </div>
              <div id={rowChartID} className="col-md-5">
                  <div className="funded">
                      <div className="title">
                          <div className="text">{rowChartHeading}</div>
                      </div>
                      <div className="content">
                          <div id={rowChartContainerID}>
                          </div>
                          <div id={rowNAContainerID} className="title" style={{textAlign: 'center'}}>
                          <canvas style={{height: '130px', width:'130px', backgroundColor: '#fff'}} id="CG2.1b" width="50" height="50" />
                              <div className="kf-number" style={{paddingTop: '70px', display: 'none'}}>N/A</div>
                          </div>
                      </div>
                  </div>
              </div>
            </div>
          );
        }
        else {
            if(indiNum==="2")
        {
            qrtChartID="chart1-2."+indiNum;
          rowChartID="chart2-2."+indiNum;
          qrtChartContainerID="quater"+indiNum;
          rowChartContainerID="indicator"+indiNum;
          qrtNAContainerID="2."+indiNum+"chart1NA";
          rowNAContainerID="2."+indiNum+"chart2NA";
      
          return(
            <div id={indDivID} className="customrow">
              <div className="pillar health-first">
                  <div className="customcontainer">
                      <div className="customrow">
                          <div className="col-md-12">
                              <h1 className="indicator-title">
                                  {heading}
                              </h1>
                          </div>
                      </div>
                  </div>
              </div>
              {/* <div className="col-md-2">
                <div className="funded">
                  <div className="body">
                    <div className="burger">
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                    </div>
                    <IndKeyFigure heading={kfHeading} div_id={kfDivID} unit="" />
                  </div>
                </div>
              </div> */}
              <div id={qrtChartID} className="col-md-4">
                <div className="funded">
                    <div className="title">
                        <div className="text">Quarterly Progress</div>
                    </div>
                    <div className="content">
                        <div id={qrtChartContainerID}>
                        </div>
                        <div id={qrtNAContainerID} className="title" style={{textAlign: 'center'}}>
                        <canvas style={{height: '130px', width:'130px', backgroundColor: '#fff'}} id="CG2.2a" width="50" height="50" />
                            <div className="kf-number" style={{paddingTop: '70px', display: 'none'}}>N/A</div>
                        </div>
                    </div>
                </div>
              </div>
              <div id={rowChartID} className="col-md-4">
                  <div className="funded">
                      <div className="title">
                          <div className="text">{rowChartHeading}</div>
                      </div>
                      <div className="content">
                          <div id={rowChartContainerID}>
                          </div>
                          <div id={rowNAContainerID} className="title" style={{textAlign: 'center'}}>
                          <canvas style={{height: '130px', width:'130px', backgroundColor: '#fff'}} id="CG2.2b" width="50" height="50" />
                              <div className="kf-number" style={{paddingTop: '70px', display: 'none'}}>N/A</div>
                          </div>
                      </div>
                  </div>
              </div>
              <div id={rowChartID} className="col-md-4">
                  <div className="funded">
                      <div className="title">
                          <div className="text">{rowChartHeading}</div>
                      </div>
                      <div className="content">
                          <div id={rowChartContainerID}>
                          </div>
                          <div id={rowNAContainerID} className="title" style={{textAlign: 'center'}}>
                          <canvas style={{height: '130px', width:'130px', backgroundColor: '#fff'}} id="CG2.2c" width="50" height="50" />
                              <div className="kf-number" style={{paddingTop: '70px', display: 'none'}}>N/A</div>
                          </div>
                      </div>
                  </div>
              </div>
            </div>
            
          );
            }
        else {
            if(indiNum==="3")
        {
            qrtChartID="chart1-2."+indiNum;
          rowChartID="chart2-2."+indiNum;
          qrtChartContainerID="quater"+indiNum;
          rowChartContainerID="indicator"+indiNum;
          qrtNAContainerID="2."+indiNum+"chart1NA";
          rowNAContainerID="2."+indiNum+"chart2NA";
      
          return(
            <div id={indDivID} className="customrow">
              <div className="pillar health-first">
                  <div className="customcontainer">
                      <div className="customrow">
                          <div className="col-md-12">
                              <h1 className="indicator-title">
                                  {heading}
                              </h1>
                          </div>
                      </div>
                  </div>
              </div>
              {/* <div className="col-md-2">
                <div className="funded">
                  <div className="body">
                    <div className="burger">
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                    </div>
                    <IndKeyFigure heading={kfHeading} div_id={kfDivID} unit="" />
                  </div>
                </div>
              </div> */}
              <div id={qrtChartID} className="col-md-4">
                <div className="funded">
                    <div className="title">
                        <div className="text">Quarterly Progress</div>
                    </div>
                    <div className="content">
                        <div id={qrtChartContainerID}>
                        </div>
                        <div id={qrtNAContainerID} className="title" style={{textAlign: 'center'}}>
                        <canvas style={{height: '130px', width:'130px', backgroundColor: '#fff'}} id="CG2.3a" width="50" height="50" />
                            <div className="kf-number" style={{paddingTop: '70px', display: 'none'}}>N/A</div>
                        </div>
                    </div>
                </div>
              </div>
              <div id={rowChartID} className="col-md-4">
                  <div className="funded">
                      <div className="title">
                          <div className="text">{rowChartHeading}</div>
                      </div>
                      <div className="content">
                          <div id={rowChartContainerID}>
                          </div>
                          <div id={rowNAContainerID} className="title" style={{textAlign: 'center'}}>
                          <canvas style={{height: '130px', width:'130px', backgroundColor: '#fff'}} id="CG2.3b" width="50" height="50" />
                              <div className="kf-number" style={{paddingTop: '70px', display: 'none'}}>N/A</div>
                          </div>
                      </div>
                  </div>
              </div>
              <div id={rowChartID} className="col-md-4">
                  <div className="funded">
                      <div className="title">
                          <div className="text">{rowChartHeading}</div>
                      </div>
                      <div className="content">
                          <div id={rowChartContainerID}>
                          </div>
                          <div id={rowNAContainerID} className="title" style={{textAlign: 'center'}}>
                          <canvas style={{height: '130px', width:'130px', backgroundColor: '#fff'}} id="CG2.3c" width="50" height="50" />
                              <div className="kf-number" style={{paddingTop: '70px', display: 'none'}}>N/A</div>
                          </div>
                      </div>
                  </div>
              </div>
            </div>
          );
            }
        else
        {
            if(indiNum==="5")
        {
            qrtChartID="chart1-2."+indiNum;
          rowChartID="chart2-2."+indiNum;
          qrtChartContainerID="quater"+indiNum;
          rowChartContainerID="indicator"+indiNum;
          qrtNAContainerID="2."+indiNum+"chart1NA";
          rowNAContainerID="2."+indiNum+"chart2NA";
      
          return(
            <div id={indDivID} className="customrow">
              <div className="pillar health-first">
                  <div className="customcontainer">
                      <div className="customrow">
                          <div className="col-md-12">
                              <h1 className="indicator-title">
                                  {heading}
                              </h1>
                          </div>
                      </div>
                  </div>
              </div>
              <div className="col-md-2">
                <div className="funded">
                  <div className="body">
                    <div className="burger">
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                        <div>&nbsp;</div>
                    </div>
                    <IndKeyFigure heading={kfHeading} div_id={kfDivID} unit="" indValue = "116 M" />
                  </div>
                </div>
              </div>
              <div id={qrtChartID} className="col-md-5">
                <div className="funded">
                    <div className="title">
                        <div className="text">Quarterly Progress</div>
                    </div>
                    <div className="content">
                        <div id={qrtChartContainerID}>
                        </div>
                        <div id={qrtNAContainerID} className="title" style={{textAlign: 'center'}}>
                        <canvas style={{height: '130px', width:'130px', backgroundColor: '#fff'}} id="CG2.5a" width="50" height="50" />
                            <div className="kf-number" style={{paddingTop: '70px', display: 'none'}}>N/A</div>
                        </div>
                    </div>
                </div>
              </div>
              <div id={rowChartID} className="col-md-5">
                  <div className="funded">
                      <div className="title">
                          <div className="text">{rowChartHeading}</div>
                      </div>
                      <div className="content">
                          <div id={rowChartContainerID}>
                          </div>
                          <div id={rowNAContainerID} className="title" style={{textAlign: 'center'}}>
                          <canvas style={{height: '130px', width:'130px', backgroundColor: '#fff'}} id="CG2.5b" width="50" height="50" />
                              <div className="kf-number" style={{paddingTop: '70px', display: 'none'}}>N/A</div>
                          </div>
                      </div>
                  </div>
              </div>
            </div>
          );
            }
          else          
          return(
          <>
            <div id="Ind2.4-1" className="cucustomrow">
            <div className="pillar protecting-people">
                <div className="customcontainer">
                    <div className="cucustomrow">
                        <div className="col-md-12">
                            <h1 className="indicator-title">
                                Gender Based Violence Measures
                            </h1>
                        </div>
                    </div>
                </div>
            </div>
  
            <div className="col-md-12">
                <div className="pillar2-4-1blocks">
                    <div className="pillar-block">
                        <div className="header">
                            <div className="text text-center">
                                ACCESS TO JUSTICE
                            </div>
                        </div>
                        <div className="body">
                            <div className="counter text-center">
                                <span id="top-number2-4a">No</span>
                                <span id="top-number2-4a-dumy" style={{display: 'none'}}></span>
                            </div>
                        </div>
                    </div>
                    <div className="pillar-block">
                        <div className="header">
                            <div className="text text-center">
                                FUNCTIONING OF SHELTERS FOR VICTIMS OF VIOLENCE
                            </div>
                        </div>
                        <div className="body">
                            <div className="counter text-center">
                                <span id="top-number2-4b">No</span>
                                <span id="top-number2-4b-dumy" style={{display: 'none'}}></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
            <div id="Ind2.4-2" className="cucustomrow">
                <div className="col-md-12">
                    <div className="pillar2-4-2blocks">
                        <div className="pillar-block">
                            <div className="header">
                                <div className="text text-center">
                                    VIOLENCE PREVENTION AND RESPONSE
                                </div>
                            </div>
                            <div className="body">
                                <div className="counter text-center">
                                    <span id="top-number2-4c">No</span>
                                    <span id="top-number2-4c-dumy" style={{display: 'none'}}></span>
                                </div>
                            </div>
                        </div>
                        <div className="pillar-block">
                            <div className="header">
                                <div className="text text-center">
                                    PROVIDE OPTIONS FOR WOMEN TO REPORT ABUSE
                                </div>
                            </div>
                            <div className="body">
                                <div className="counter text-center">
                                    <span id="top-number2-4d">No</span>
                                    <span id="top-number2-4d-dumy" style={{display: 'none'}}></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="Ind2.4-3" className="cucustomrow">
                <div className="col-md-12">
                    <div className="pillar2-4-3blocks">
                        <div className="pillar-block">
                            <div className="header">
                                <div className="text text-center">
                                    RAISE AWARENESS THROUGH ADVOCACY AND CAMPAIGNS
                                </div>
                            </div>
                            <div className="body">
                                <div className="counter text-center">
                                    <span id="top-number2-4e">No</span>
                                    <span id="top-number2-4e-dumy" style={{display: 'none'}}></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </>
          )
  }
}
}
}  
export default Pillar2;